/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Modal_Add_TitleInputs */

const en_task_modal_add_title = /** @type {(inputs: Task_Modal_Add_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add new task`)
};

const pt_br2_task_modal_add_title = /** @type {(inputs: Task_Modal_Add_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar nova atividade`)
};

/**
* | output |
* | --- |
* | "Add new task" |
*
* @param {Task_Modal_Add_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_modal_add_title = /** @type {((inputs?: Task_Modal_Add_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Modal_Add_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_modal_add_title(inputs)
	return pt_br2_task_modal_add_title(inputs)
});